<template>
    <div>
        <div class="afu-w-full afu-p-3 sm:afu-p-6 afu-bg-white afu-shadow-lg afu-rounded-md afu-m-auto sm:afu-max-w-xl afu-w-100">
            <div class="afu-text-center afu-mb-5">
                <h5>{{ $t('reset_password.title') }}</h5>

                <p class="afu-mb-0">
                    {{ $t('reset_password.info') }}
                </p>
            </div>

            <C1Alert
                v-if="!!response.message"
                :variant="response.status"
            >
                <span v-html="response.message" />
            </C1Alert>

            <ValidationObserver
                ref="resetPasswordForm"
                tag="form"
                class="afu-grid afu-row-gap-4"
                @submit.prevent="resetPassword()"
            >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="email"
                    rules="required|email"
                >
                    <C1FormGroup>
                        <C1FormInput
                            v-model="email"
                            :is-invalid="!!errors[0]"
                            :invalid-feedback="errors[0]"
                            name="email"
                            type="email"
                            :placeholder="$t('label.email_address')"
                        />
                    </C1FormGroup>
                </ValidationProvider>

                <ValidationProvider
                    v-slot="{ errors }"
                    name="password"
                    rules="required|verify_password"
                >
                    <C1FormGroup>
                        <C1FormInput
                            v-model="password"
                            :is-invalid="!!errors[0]"
                            :invalid-feedback="errors[0]"
                            type="password"
                            name="password"
                            :placeholder="$t('label.enter_new_password')"
                        />
                    </C1FormGroup>
                </ValidationProvider>

                <C1Button
                    type="submit"
                    variant="primary"
                    size="lg"
                    block
                    :is-busy="spinner.reset_password"
                >
                    {{ $t('label.create_password') }}
                </C1Button>
            </ValidationObserver>
        </div>

        <div class=" afu-text-center afu-mt-5 md:afu-mt-10">
            <a
                href="/user-login"
                class="text-sm afu-text-primary-400 hover:afu-text-primary-400 afu-underline hover:afu-no-underline"
            >
                {{ $t('register.back') }}
            </a>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import { ValidationObserver, ValidationProvider } from 'vee-validate';
    import C1Alert from '@/components/C1Components/C1Alert';
    import C1FormInput from '@/components/C1Components/C1FormInput';
    import C1Button from '@/components/C1Components/C1Button';
    import C1FormGroup from '@/components/C1Components/C1FormGroup';

    export default {
        name: 'ResetPassword',

        components: {
            C1FormGroup,
            ValidationObserver,
            ValidationProvider,
            C1Alert,
            C1FormInput,
            C1Button,
        },

        data() {
            return {
                email: '',
                password: '',
                response: {
                    status: '',
                    message: '',
                },
                spinner: {
                    reset_password: false,
                },
            };
        },

        computed: {
            ...mapState({
                $_apiMessage: state => state.apiMessage,
            }),
        },

        created() {
            const urlParams = new URLSearchParams(window.location.search);
            this.token = urlParams.get('token');

            if (!this.token) {
                window.location.href = '/user-login';
            }
        },

        methods: {
            ...mapActions('auth', {
                $_resetPassword: 'resetPassword',
            }),

            async resetPassword() {
                const validation = await this.$refs.resetPasswordForm.validate();
                if (!validation) {
                    return false;
                }

                this.response.status = '';
                this.response.message = '';

                this.spinner.reset_password = true;
                this.$_resetPassword({ email: this.email, password: this.password, token: this.token }).then(() => {
                    this.response.status = 'success';
                    this.response.message = this.$t('reset_password.success');
                    window.location.href = '/user-login/';
                }).catch((error) => {
                    const errorCode = error?.response?.data?.error || 'ServerErrorException';
                    this.response.status = 'danger';
                    this.response.message = this.$_apiMessage[errorCode];
                }).finally(() => {
                    this.spinner.reset_password = false;
                });
            },
        },
    };
</script>
